<template>
  <modal :visible.sync="isVisible"
         width="560px"
         height="650px">
    <template slot="header">
      <span class="custom-furniture__title">
        {{ $t('inventory.customFurniture.labels.title') }}
      </span>
    </template>
    <div class="custom-furniture__body">
      <!-- <camera-button/> -->
      <div class="custom-furniture__body__label">
        <input-label :text="$t('inventory.customFurniture.labels.name')"/>
        <el-input v-model="customFurniture.nom_type"
                  :placeholder="$t('inventory.customFurniture.labels.placeholder')"/>
      </div>
      <div class="custom-furniture__body__form">
        <div class="custom-furniture__body__form__values">
          <div class="custom-furniture__body__form__values__input">
            <input-label :text="$t('inventory.customFurniture.labels.length')"/>
            <input-number v-model="customFurniture.length"
                          :height="50"
                          :width="150"
                          :min="0"
                          :step="10"
                          @change="onLengthChange" />
          </div>
          <div class="custom-furniture__body__form__values__input">
            <input-label :text="$t('inventory.customFurniture.labels.width')"/>
            <input-number v-model="customFurniture.width"
                          :height="50"
                          :width="150"
                          :min="0"
                          :step="10"
                          @change="onWidthChange" />
          </div>
          <div class="custom-furniture__body__form__values__input">
            <input-label :text="$t('inventory.customFurniture.labels.height')"/>
            <input-number v-model="customFurniture.height"
                          :height="50"
                          :width="150"
                          :min="0"
                          :step="10"
                          @change="onHeightChange" />
          </div>
        </div>
      </div>
    </div>
    <div class="custom-furniture__error" v-for="error in errors" :key="error">
      {{ error }}
    </div>
    <template slot="footer">
      <el-button type="primary"
                 :disabled="!isValidForm"
                 class="custom-furniture__button"
                 @click="createFurniture">
        {{ $t('inventory.customFurniture.create') }}
      </el-button>
    </template>
  </modal>
</template>
<script>
import InputLabel from '@/components/utils/InputLabel.vue';
import InputNumber from '@/components/utils/InputNumber.vue';
import Modal from '@/components/utils/Modal.vue';
// import CameraButton from '@/components/furnitures/modals/CameraButton.vue';


export default {
  name: 'custom-furniture-modal',
  components: {
    InputLabel, Modal, InputNumber,
  },
  props: {
    value: {
      type: Object,
      validator(value) {
        return value.width !== undefined
          && value.length !== undefined
          && value.height !== undefined
          && value.nom_type !== undefined
          && value.fragile !== undefined;
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: [],
      displayAddPicture: false,
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('visibilityChange', value);
      },
    },
    customFurniture: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit('input', value);
      },
    },
    customFurnitureVolume() {
      return (this.customFurniture.width
        * this.customFurniture.length
        * this.customFurniture.height)
        / 1000000;
    },
    isValidForm() {
      return this.customFurnitureVolume > 0
        && this.customFurniture.nom_type;
    },
    isMobile() {
      return this.$store.getters['dimensionStore/isMobile'];
    },
  },
  methods: {
    onLengthChange(value) {
      this.customFurniture.length = value;
    },
    onWidthChange(value) {
      this.customFurniture.width = value;
    },
    onHeightChange(value) {
      this.customFurniture.height = value;
    },
    validateForm() {
      const WIDTH_ERROR = this.$t('inventory.customFurniture.errors.width');
      const LENGTH_ERROR = this.$t('inventory.customFurniture.errors.length');
      const HEIGHT_ERROR = this.$t('inventory.customFurniture.errors.height');
      const NAME_ERROR = this.$t('inventory.customFurniture.errors.name');

      if (this.customFurniture.width === 0) {
        const index = this.errors.findIndex(error => error === WIDTH_ERROR);
        if (index === -1) this.errors.push(WIDTH_ERROR);
      } else {
        const index = this.errors.findIndex(error => error === WIDTH_ERROR);
        if (index !== -1) this.errors.splice(index, 1);
      }
      if (this.customFurniture.length === 0) {
        const index = this.errors.findIndex(error => error === LENGTH_ERROR);
        if (index === -1) this.errors.push(LENGTH_ERROR);
      } else {
        const index = this.errors.findIndex(error => error === LENGTH_ERROR);
        if (index !== -1) this.errors.splice(index, 1);
      }
      if (this.customFurniture.height === 0) {
        const index = this.errors.findIndex(error => error === HEIGHT_ERROR);
        if (index === -1) this.errors.push(HEIGHT_ERROR);
      } else {
        const index = this.errors.findIndex(error => error === HEIGHT_ERROR);
        if (index !== -1) this.errors.splice(index, 1);
      }
      if (this.customFurniture.nom_type === '') {
        const index = this.errors.findIndex(error => error === NAME_ERROR);
        if (index === -1) this.errors.push(NAME_ERROR);
      } else {
        const index = this.errors.findIndex(error => error === NAME_ERROR);
        if (index !== -1) this.errors.splice(index, 1);
      }
    },
    createFurniture() {
      this.validateForm();
      if (this.errors.length === 0) this.$emit('create-furniture');
    },
    addPicture() {
      this.displayAddPicture = true;
    },
  },
};
</script>
<style lang="scss" scoped>
input[type=file] {
  border: none;
  background-color: transparent;
  overflow: hidden;
  opacity: 0;
}

.custom-furniture {
  &__title {
    font-weight: 600;
  }

  &__body {
    text-align: left;

    &__label {
      margin-top: 10px;
      font-weight: 600;
    }

    &__form {
      display: grid;
      grid-template-columns: auto;
      @media all and (min-width: 800px) {
        grid-template-columns: auto auto;
      }

      &__values {
        height: 100%;
        &--camera {
          display: flex;
          flex-direction: row;
        }

        &__input {
          margin: 8px 0;
        }
      }

      &__volume {
        margin: 8px 0;

        &__label {
          line-height: 25px;
        }

        &__value {
          border: 0.5px solid $--color-secondary;
          border-radius: $--border-radius-base;
          display: grid;
          place-content: center;
          height: 40px;
          @media all and (min-width: 800px) {
            height: calc(100% - 25px);
            max-width: 200px;
          }


          &__exposant {
            vertical-align: super;
          }
        }
      }
    }

    &__options {
    }
  }

  &__button {
    width: 200px;
  }

  &__error {
    text-align: left;
    color: $--color-danger
  }
}

</style>
